import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { useSettings } from '../../context/SettingsContext';
import { SECTIONS, sectionHook } from '../../lib/domHooks';

// Referans vitrinindeki "Sıkça Sorulan Sorular" akordeonu.
//
// Metin **panelden yönetilir** (`settings.home_faq_items`), koda gömülmez —
// sorular kuruluma göre değişir ve yazılım çok alıcıya satılıyor. Liste
// boşsa bölüm hiç çizilmez.
//
// Cevap **düz metin olarak** basılır; `dangerouslySetInnerHTML` bilinçli
// olarak kullanılmaz. Panelden gelen metin güvenilir sayılsa bile portalda
// çalışan bir HTML alanı, yönetici hesabı ele geçirildiğinde depolanmış
// XSS'e dönüşürdü (SVG yüklemesindeki gerekçenin aynısı).
const HerkulFaq = () => {
  const settings = useSettings();
  const items = Array.isArray(settings.home_faq_items) ? settings.home_faq_items : [];
  // Tek seferde tek soru açılır: hepsi birden açıkken liste sayfayı
  // uzatıp aranan soruyu bulmayı zorlaştırıyordu.
  const [open, setOpen] = useState(null);

  const visible = items.filter((item) => (item?.question || '').trim());
  if (!visible.length) return null;

  return (
    <section className="herkul-faq" {...sectionHook(SECTIONS.FAQ)}>
      <div className="herkul-section-head">
        <div className="herkul-section-title-wrap">
          <span className="herkul-section-icon is-blue"><HelpCircle size={17} /></span>
          <div className="herkul-section-heading">
            <h2 className="herkul-section-title">Sıkça Sorulan Sorular</h2>
            <p className="herkul-section-sub">Aradığını bulamazsan canlı destek 7/24 açık</p>
          </div>
        </div>
      </div>

      <div className="herkul-faq-list">
        {visible.map((item, index) => {
          const isOpen = open === index;
          return (
            <div className={`herkul-faq-item ${isOpen ? 'is-open' : ''}`} key={item.question}>
              <button
                type="button"
                className="herkul-faq-q"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? null : index)}
              >
                <span>{item.question}</span>
                <ChevronDown size={17} className="herkul-faq-caret" />
              </button>
              {isOpen && <p className="herkul-faq-a">{item.answer}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HerkulFaq;
